/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockDatas.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Data Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 28, 2018 - 06:48:21 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      10/28/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCKDATA_LIST_CONTAINER_LOADED = 'BLOCKDATA_LIST_CONTAINER_LOADED';
export const BLOCKDATA_LIST_CONTAINER_UNLOADED = 'BLOCKDATA_LIST_CONTAINER_UNLOADED';
export const BLOCKDATA_LIST_TABLE_LOADED = 'BLOCKDATA_LIST_TABLE_LOADED';
export const BLOCKDATA_LIST_TABLE_UNLOADED = 'BLOCKDATA_LIST_TABLE_UNLOADED';

export const BLOCKDATA_LIST_CHANGE_GROUP = 'BLOCKDATA_LIST_CHANGE_GROUP';
export const BLOCKDATA_SELECT_ROW = 'BLOCKDATA_SELECT_ROW';

export const BLOCKDATA_ADD = 'BLOCKDATA_ADD';
export const BLOCKDATA_EDIT = 'BLOCKDATA_EDIT';
export const BLOCKDATA_DELETE = 'BLOCKDATA_DELETE';
export const BLOCKDATA_OPEN_WARNING = 'BLOCKDATA_OPEN_WARNING';
export const BLOCKDATA_CLOSE_WARNING = 'BLOCKDATA_CLOSE_WARNING';

export const BLOCKDATA_EDIT_CONTAINER_LOADED = 'BLOCKDATA_EDIT_CONTAINER_LOADED';
export const BLOCKDATA_EDIT_CONTAINER_UNLOADED = 'BLOCKDATA_EDIT_CONTAINER_UNLOADED';
export const BLOCKDATA_EDIT_COMPANIES_LOADED = 'BLOCKDATA_EDIT_COMPANIES_LOADED';
export const BLOCKDATA_EDIT_USERS_LOADED = 'BLOCKDATA_EDIT_USERS_LOADED';
export const BLOCKDATA_EDIT_BLOCKGROUP_LOADED = 'BLOCKDATA_EDIT_BLOCKGROUP_LOADED';
export const BLOCKDATA_EDIT_BLOCKTREE_LOADED = 'BLOCKDATA_EDIT_BLOCKTREE_LOADED';
export const BLOCKDATA_EDIT_DRAW_COMPANYOPTIONS = 'BLOCKDATA_EDIT_DRAW_COMPANYOPTIONS';
export const BLOCKDATA_EDIT_DRAW_USEROPTIONS = 'BLOCKDATA_EDIT_DRAW_USEROPTIONS';
export const BLOCKDATA_EDIT_DRAW_BLOCKTREE = 'BLOCKDATA_EDIT_DRAW_BLOCKTREE';
export const BLOCKDATA_EDIT_BLOCKFORMAT_LOADED = 'BLOCKDATA_EDIT_BLOCKFORMAT_LOADED';

export const BLOCKDATA_UPDATE_VALUE = 'BLOCKDATA_UPDATE_VALUE';

export const BLOCKDATA_EDIT_FORM_LOADED = 'BLOCKDATA_EDIT_FORM_LOADED';
export const BLOCKDATA_EDIT_FORM_UNLOADED = 'BLOCKDATA_EDIT_FORM_UNLOADED';

export const BLOCKDATA_SET_GROUP_SELECT = 'BLOCKDATA_SET_GROUP_SELECT';
export const BLOCKDATA_EDIT_DATA_LOAD = 'BLOCKDATA_EDIT_DATA_LOAD';

export const BLOCKDATA_EDIT_CONTAINER_SUBMIT = 'BLOCKDATA_EDIT_CONTAINER_SUBMIT';
export const BLOCKDATA_EDIT_CONTAINER_CANCEL = 'BLOCKDATA_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockDatas.js